<template>
    <div>
        <div class="search-box">
            <p>项目类型：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.projectTypeCode" :filter-option="filterOption">
                <a-select-option v-for="(item,index) in xmlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>项目名称：</p>
            <a-input class="input-box" v-model="searchFrom.projectName" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <div class="operation-box">
            <a-button type="primary" v-if="permissions.indexOf('undergraduate:student:innovate:add')>-1" icon="plus" class="btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() :remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:student:innovate:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0]==null?selectedCheck() :$refs.info.showDrawer('编辑',selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:student:innovate:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" v-if="permissions.indexOf('undergraduate:student:innovate:query')>-1" @click="selectedRowKeys[0]==null?selectedCheck() :$refs.info.showDrawer('查看',selectedRowKeys[0])" >查看详情</a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <template slot="decideDate" slot-scope="text">{{text}}年</template>
            <template slot="projectTypeCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.projectTypeCode" disabled>
                    <a-select-option v-for="(item,index) in xmlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <!-- <template slot="createTime" slot-scope="text,record">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',record.id)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',record.id)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(record.id)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/undergraduate/student/innovate'
    import Info from './modules/innovateInfo'
    import { selectedCheck } from '@/baseAPI/util'

    const columns = [
        {
            title: '序号',
            dataIndex: 'lastUpdateTime',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '编号',
            dataIndex: 'id',
            align:'center'
        },
        {
            title: '立项时间',
            dataIndex: 'decideDate',
            align:'center',
            scopedSlots: { customRender: 'decideDate' }
        },
        {
            title: '项目类型',
            dataIndex: 'projectTypeCode',
            align:'center',
            scopedSlots: { customRender: 'projectTypeCode' }
        },
        {
            title: '项目名称',
            dataIndex: 'projectName',
            align:'center'
        },
        {
            title: '项目负责人',
            dataIndex: 'chargeStudentName',
            align:'center'
        },
        {
            title: '指导老师',
            dataIndex: 'guideTeacherName',
            align:'center'
        },
        {
            title: '经费',
            dataIndex: 'projectFunds',
            align:'center'
        },
        {
          title: '操作',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                selectedRowKeys: [],
                permissions:[],
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    projectTypeCode:'',
                    projectName:'',
                },
                xmlxArr:[],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;

            this.fetch()
            getDicts({dataCode:'CXXMLX',status:true}).then(res=>{
                this.xmlxArr=res.data.dicts;
            })
        },
        methods:{
            selectedCheck(){
                selectedCheck()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除创新项目成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
